import Img from "../../../Utils/Ratio";
import Weather from "../../../assets/images/dashboard/weather.png";
import { Card, CardHeader, Col } from "reactstrap";
import { UL, LI, H5, H3, P, Btn } from "../../../AbstractElements";
import { FiMoon, FiRefreshCcw } from "react-icons/fi";
import { useGeolocated } from "react-geolocated";
import {
  BeautifulSunnyDayWalk,
  Cool,
  Night,
  OurCityWeatherTitle,
  Refresh,
  SeeYourCityWeather,
} from "../../../Constant";

const formatDegrees = (degrees) =>
  `${0 | degrees}°${
    0 | (((degrees < 0 ? (degrees = -degrees) : degrees) % 1) * 60)
  } `;

const WeatherCard = () => {
  const { coords, isGeolocationAvailable, isGeolocationEnabled, getPosition } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });

  return (
    <Col xl="3" lg="6" md="5" sm="6" className="box-col-6 our-city">
      <Card className=" weather-sec">
        <CardHeader className="card-no-border pb-0">
          <H5>{OurCityWeatherTitle}</H5>
          <div className="center-content">
            <P>{SeeYourCityWeather}</P>
          </div>

          <div className="city-weather">
            <UL className="weather-wrraper d-block">
              <LI>
                <H3>
                  {!isGeolocationAvailable ? (
                    <div>Your browser does not support Geolocation.</div>
                  ) : !isGeolocationEnabled ? (
                    <div>Geolocation is not enabled.</div>
                  ) : coords ? (
                    formatDegrees(coords.latitude)
                  ) : (
                    <div>Getting the location data&hellip;</div>
                  )}
                  C
                </H3>
                <span></span>
              </LI>
              <LI>
                <div className="icon-moon">
                  <FiMoon />
                </div>
              </LI>
              <LI>
                <Btn
                  color="primary"
                  onClick={getPosition}
                  className="d-flex align-items-center"
                >
                  <FiRefreshCcw className="me-2" />
                  {Refresh}
                </Btn>
              </LI>
            </UL>
            <span>
              {`${Cool} 
              ${Night}`}
            </span>
            <P>{BeautifulSunnyDayWalk}</P>
          </div>
        </CardHeader>
        <div className="card-body weather-img">
          <Img className="img-fluid bg-img bg-img-cover" src={Weather} alt="" />
          <div className="ag-snow"></div>
        </div>
      </Card>
    </Col>
  );
};
export default WeatherCard;
